<template>
  <v-flex
    d-flex
    class="pr-2"
    v-if="selectedClient"
  >
    <span>Outfox AI</span>
    <span class="px-2">for</span>
    <div v-if="selectedClient.logoLink">
      <img
        :src="selectedClient.logoLink"
        height="28px"
        style="vertical-align:middle"
      >
    </div>
  </v-flex>
</template>

<script>
export default {
  name: 'header-component-client-info',
  data () {
    return {}
  },
  computed: {
    selectedClient () {
      const user = this.$store.getters.getCurrentUser
      if (!user || !user.firebaseAccount) return false
      const selectedAdvertiser = user.firebaseAccount.selectedAdvertiser
      const advertiser = this.$store.getters.getAdvertisers.find(a => a.id === selectedAdvertiser)
      if (advertiser) return advertiser.data
      return false
    }
  }
}
</script>
